import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { useLicencePayment } from "src/Utils/Hooks/Payments/usePayment";
import { useResubscribe } from "src/Utils/Hooks/Payments/useResubscribe";

interface IResubscribe {
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    priceId: string;
    isSubscriptionExpired: boolean;
}

const Resubscribe: React.FC<IResubscribe> = ({clinicId, setInfo, updatePageLoader, priceId, isSubscriptionExpired}) => {
    const { t } = useTranslation();
    const { checkoutUrl, createLicensePaymentPage, reqestLoading, reqestError} = useLicencePayment();
    const {reqestResponse, reqestError: resubscribeError, reqestLoading: resubscribeLoading, resubscribeSubscription} = useResubscribe();
    
    useEffect(() => {
        updatePageLoader(reqestLoading) 
    }, [reqestLoading, updatePageLoader]);

    useEffect(() => {
        updatePageLoader(resubscribeLoading) 
    }, [resubscribeLoading, updatePageLoader]);

    useEffect(() => {
        if (checkoutUrl) {
            window.open(checkoutUrl, '_self');
        }
    }, [checkoutUrl]);

    useEffect(() => {
        if(reqestResponse){
            setInfo('License subscription resubscribed successfully.', InfoMessageType.success);
        }
    }, [reqestResponse, setInfo]);

    useEffect(() => {
        if (reqestError !== '') {
            setInfo(reqestError, InfoMessageType.error);
        } 
    },[reqestError, setInfo])

    useEffect(() => {
        if (resubscribeError !== '') {
            setInfo(resubscribeError, InfoMessageType.error);
        } 
    },[resubscribeError, setInfo])

    const handleResubscribe = () => {
        isSubscriptionExpired ? createLicensePaymentPage(priceId, clinicId) : resubscribeSubscription(clinicId);
    }

    return(
        <>
            <div onClick={handleResubscribe} className="dropdown-item" id="resubscribe">
                {t('Resubscribe')}
            </div>
        </>
    );
}

export default Resubscribe;